/**
 * Set up routing for all UserNode views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import userNode views
import CreateUserNode from './views/CreateUserNode.js.jsx';
import UserNodeList from './views/UserNodeList.js.jsx';
import SingleUserNode from './views/SingleUserNode.js.jsx';
import UpdateUserNode from './views/UpdateUserNode.js.jsx';

class UserNodeRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user-nodes" component={UserNodeList} />
        <YTRoute login={true} exact path="/user-nodes/new" component={CreateUserNode} />
        <Route exact path="/user-nodes/:userNodeId" component={SingleUserNode}/>
        <YTRoute login={true} exact path="/user-nodes/:userNodeId/update" component={UpdateUserNode}/>
      </Switch>
    )
  }
}

export default UserNodeRouter;



// WEBPACK FOOTER //
// modules/userNode/UserNodeRouter.js.jsx